module.exports = __webpack_public_path__ + "static/media/birthdayCele.0798659c.jpg";